import styled from 'styled-components';

export const Container = styled.section`
  border-radius: 4px;
  display: flex;
  font-family: 'Oswald', sans-serif;
  font-size: 42px;
  zoom: ${({ isBuilder }) => (isBuilder ? '0.8' : 'normal')};
`;
Container.displayName = 'Container';

export const DownDistance = styled.div`
  min-width: 45px;
`;
DownDistance.displayName = 'DownDistance';

export const DownDistanceContainer = styled.div`
  align-items: center;
  background-color: #ccc;
  border-radius: 4px 0 0 4px;
  color: #000;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 100px;
  padding: 0 16px;
  text-align: center;
`;
DownDistanceContainer.displayName = 'DownDistanceContainer';

export const Points = styled.div`
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #ccc;
  color: #000;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 100px;
  padding: 0 16px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const QuarterTime = styled.div`
  align-items: center;
  background-color: #ccc;
  color: #000;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 50px;
  padding: 0 12px;
  text-align: center;
`;
QuarterTime.displayName = 'QuarterTime';

export const Space = styled.div`
  padding: 0 4px;
`;
Space.displayName = 'Space';

export const TeamName = styled.div`
  background-color: #eee;
  color: #000;
  display: flex;
  justify-content: center;
  min-width: 190px;
  padding: 0 32px 4px;
  position: relative;
  text-align: center;

  &:before {
    content: ${({ hasPossession }) => (hasPossession ? `"●"` : '')};
    position: absolute;
    top: -2px;
    left: 4px;
  }
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #333;
  border-radius: 0 4px 4px 0;
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 130px;
  padding: 0 16px;
  text-align: center;
`;
Timer.displayName = 'Timer';

export const Timeouts = styled.div`
  background-color: #808080;
  height: 3px;
  margin: 0 8px;
  width: 36px;
`;
Timeouts.displayName = 'Timeouts';

export const TimeoutsContainer = styled.div`
  bottom: 5px;
  display: flex;
  justify-content: center;
  position: absolute;
`;
TimeoutsContainer.displayName = 'TimeoutsContainer';
